import React from 'react'

import HorizontalSliderItem from 'views/components/organisms/SliderHorizontal/ProductSliderItem'
import {
  COLUMNS,
  IMAGE_MAX_WIDTH,
  IMAGE_MIN_WIDTH,
} from 'views/components/organisms/SliderHorizontal/ProductSliderItem/consts'
import { calculateSliderImageSize } from 'views/components/organisms/SliderHorizontal/ProductSliderItem/helpers'
import { SliderListItems } from 'views/components/organisms/SliderHorizontal/SliderItemsList'

type SliderProduct = {
  id: string
}

const getSliderItems = (
  products: SliderProduct[],
  noSlider: boolean,
  showBuyButton: boolean,
  wid: number
) =>
  products.map((product, idx) => (
    <HorizontalSliderItem
      key={product.id}
      product={product}
      imageMinWidth={IMAGE_MIN_WIDTH}
      imageMaxWidth={IMAGE_MAX_WIDTH}
      imageSizes={{
        base: calculateSliderImageSize(1),
        tiny: calculateSliderImageSize(COLUMNS / 2),
        medium: calculateSliderImageSize(COLUMNS),
      }}
      thumbnail
      index={idx}
      noSlider={noSlider}
      showBuyButton={showBuyButton}
      wid={wid}
    />
  ))

const MoreProductsContainerSlider: React.VFC<{
  products: SliderProduct[]
  noSlider: boolean
  showBuyButton: boolean
  wid: number
}> = ({ products, noSlider, showBuyButton, wid }) => {
  return (
    <ul className="o-SliderHorizontal__list o-SliderHorizontal__show-more-container o-SliderHorizontal__list--no-slider a-list-reset u-position--relative u-padding--top">
      <SliderListItems
        items={getSliderItems(products, noSlider, showBuyButton, wid)}
        colSize={12 / COLUMNS}
        noSlider={noSlider}
        showBuyButton={showBuyButton}
      />
    </ul>
  )
}

export default MoreProductsContainerSlider
